import { Checkbox, Col, Form, Input, message, Row, Spin } from "antd";
import SubmitButton from "../../form/SubmitButton.tsx";
import { IndividualSearchType } from "../../../lib/types.ts";
import { useEffect, useState } from "react";
import { CheckboxField } from "@aws-amplify/ui-react";
import { individualSearch } from "../../../lib/consultaIndividual.ts";
import SearchResultsPage from "../../../router/SearchResultTable.tsx";
import { usePostHog } from "posthog-js/react";
import { useDebouncedPostHogCapture } from "../../../lib/postHogHelper.ts";
import InputIcon from '../../../assets/svg/inputIcon.svg';
import InputMask from "react-input-mask";
import { readLeadList } from "../../../lib/readLeadList.ts";

interface FormProps {
  label: string;
  placeholder?: string;
  menu: IndividualSearchType;
  mask?: string;
  handler: () => void;
}

const SearchForm = (props: FormProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [resultData, setResultData] = useState<[]>([]);
  const [value, setValue] = useState<string>("");
  const posthog = usePostHog();
  const debouncedPostHogCapture = useDebouncedPostHogCapture();
  const [path, setPath] = useState<string | undefined>(undefined)

  const inputSize = () => {
    if (props.menu === IndividualSearchType.CNPJ) return 18;
    if (props.menu === IndividualSearchType.CNPJ_RAIZ) return 10;
    if (props.menu === IndividualSearchType.CPF) return 14;
    return 200;
  };

  const sumbitHandler = () => {
    if ((props.menu === IndividualSearchType.CNPJ || props.menu === IndividualSearchType.CNPJ_RAIZ || props.menu === IndividualSearchType.CPF) && value.length !== inputSize()) return;
    else if(value.length<3 || value.length>inputSize()) return
    setLoading(true);

    let param = {};
    if (props.menu === IndividualSearchType.CNPJ) param = { cnpj: value };
    if (props.menu === IndividualSearchType.CNPJ_RAIZ)
      param = { cnpj_basico: value };
    if (props.menu === IndividualSearchType.NOME_FANTASIA)
      param = { nome_fantasia: value };
    if (props.menu === IndividualSearchType.RAZAO_SOCIAL)
      param = { razao_social: value };
    if (props.menu === IndividualSearchType.NOME_SOCIO)
      param = { nome_socio: value };
    if (props.menu === IndividualSearchType.CPF) param = { cpf: value };
    if(props.menu === IndividualSearchType.DOMINIO) param = {dominio: value}

    individualSearch(param).then((response) => {
      console.log(response);

      if (response.body && response.statusCode === 200) {
        const path = response.body
        localStorage.setItem("leadPath", path);
        setPath(path)

        const fetchData = ()=>{
          readLeadList(path).then(response=>{
            if(!response.length) setTimeout(fetchData,5000)
            else{ 
              setResultData(response)
              setLoading(false)
            }
          })
        }
        fetchData()
        
      } else {
        if(response.body){
          message.error("Houve um erro na pesquisa: " + response.body);
        }
        else{
          message.error("Houve um erro na pesquisa: " + response.errorMessage);
        }
      }
    });
  };

  return (
    <Col
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Col
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Form.Item
          style={{ marginTop: "1.5em" }}
          label={props.label}
          colon={false}
          rules={[
            { required: true, message: "Campo obrigatório" },
          ]}
        >
          {props.mask ? (
            <InputMask
              mask={props.mask ?? ""}
              maskChar=""
              value={value}
              onChange={(e) => {
                debouncedPostHogCapture("individual_search_input");
                if (e.target.value.length <= inputSize()) setValue(e.target.value);
              }}
            >
              {(inputProps: any) => (
                <Input
                  {...inputProps}
                  type="text"
                  className="LeadGenerationInput"
                  placeholder={props.placeholder}
                  required={true}
                  suffix={<InputIcon />}
                />
              )}
            </InputMask>
          ) : (
            <Input
              type="text"
              className="LeadGenerationInput"
              placeholder={props.placeholder}
              value={value}
                required={true}
                onChange={(e) => {
                  debouncedPostHogCapture("individual_search_input");
                  if (e.target.value.length <= inputSize()) setValue(e.target.value);
                }}
                suffix={<InputIcon />}
              />
          )}

        </Form.Item>
      </Col>
      <Form.Item
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <SubmitButton
          text="Buscar"
          isSearch
          onClick={()=>{
            posthog.capture("buscar_individual_search_botao");
            sumbitHandler();
          }}
          loading={loading}
        />
      </Form.Item>
      <div style={{width: '150vh'}}>
      {resultData.length === 0 ? (
        <></>
      ) : (
        <SearchResultsPage
          receivedData={resultData}
          individualSearchTable={true}
          pathProp={path}
        />
      )}
      </div>
    </Col>
  );
};

export default SearchForm;
